module.exports = __webpack_public_path__ + "static/media/logo_gwo_sygnet.37080531.svg";